import { rest } from 'msw'
import type { ApprovalPreferences } from 'types/approvals'

const getAccountApprovalsPreference = rest.get<{}>(
  `${API_URL}/api/approval/v3/preferences/all-preference-status`,
  async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(true))
  }
)

export const updateAccountApprovalsPreference = rest.put<{}>(
  `${API_URL}/api/approval/v3/preferences`,
  async (req, res, ctx) => {
    return res(ctx.json(200))
  }
)

export const getApprovalsPreferenceWithFlows = (preferences: ApprovalPreferences[]) =>
  rest.get(`*/api/approval/v3/preferences/all-preference-status`, (_req, res, ctx) => {
    return res(ctx.json({ preferences }))
  })

export const getApprovalsPreferenceLoading = rest.get(
  `*/api/approval/v3/preferences/all-preference-status`,
  (_req, res, ctx) => {
    return res(ctx.delay('infinite'))
  }
)

export default [getAccountApprovalsPreference, updateAccountApprovalsPreference]
